import script from "./FullScreenImg.vue?vue&type=script&setup=true&lang=js"
export * from "./FullScreenImg.vue?vue&type=script&setup=true&lang=js"

import "./FullScreenImg.vue?vue&type=style&index=0&id=3209686d&lang=scss"

const __exports__ = script;

export default __exports__